import React from 'react';
import { useTypedDispatch } from '../../app/store';
import { logout } from '../../features/loginSlice/loginSlice';
import { useNavigate } from 'react-router-dom';

export const ButtonLogout = () => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const handleLogout = (e: React.MouseEvent<SVGSVGElement>) => {
    e.preventDefault();
    dispatch(logout());
    navigate('/');
  };
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
        cursor="pointer"
        onClick={(e) => handleLogout(e)}
        className="heartbeat"
      >
        <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" />
      </svg>
    </div>
  );
};
